<template>
  <b-card title="تسویه ها" no-body>
    <b-modal
      id="settlment"
      title="تسویه حساب"
      @ok.prevent="save"
      ok-title="ذخیره"
      cancel-title="انصراف"
    >
      <div v-if="activeGateway != null">
        <b-form-group label="شماره شبا ی واریز وجه:">
          <div class="form-control text-right" style="word-spacing: 6px">
            {{ activeGateway.shaba_number.match(/.{1,4}/g).join("  ") }}
          </div>
        </b-form-group>
        <b-form-group label="موجودی قابل برداشت:">
          <div class="form-control text-right" style="word-spacing: 6px">
            {{ Number(activeGateway.willpayfuture).toLocaleString() }}
          </div>
        </b-form-group>
        <b-form-group label="مبلغ درخواستی:">
          <number-seprator
            class="text-right"
            v-model="activeGateway.amount"
          ></number-seprator>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal
      id="transactionDetails"
      title="جزییات تسویه"
      ok-only
      ok-title="بستن"
    >
      <div v-if="docDetails != null">
        <b-form-group label="درگاه:">
          <div class="form-control" style="word-spacing: 6px">
            {{ docDetails.website_name }}
          </div>
        </b-form-group>
        <b-form-group label="برداشت از:" v-if="false">
          <div class="form-control text-right" style="word-spacing: 2px">
            ({{ docDetails.pgnickname }})
            {{ docDetails.pgsheba.match(/.{1,4}/g).join("  ") }}
          </div>
        </b-form-group>
        <b-form-group label="مبلغ واریز:">
          <div class="form-control">
            {{ Number(docDetails.bed).toLocaleString() }} ريال
          </div>
        </b-form-group>
        <b-form-group label="واریز به:">
          <div class="form-control text-right" style="word-spacing: 2px">
            ({{ docDetails.nickname }})
            {{ docDetails.shaba_number.match(/.{1,4}/g).join("  ") }}
          </div>
        </b-form-group>
        <b-form-group label="کد رهگیری:">
          <div class="form-control text-right" style="word-spacing: 2px">
            {{ docDetails.tracking_number }}
          </div>
        </b-form-group>
      </div>
    </b-modal>
    <b-card-body v-if="!dataLoaded">
      <b-skeleton
        type="button"
        class="ml-1"
        style="display: inline-block"
      ></b-skeleton>
      <b-skeleton
        type="button"
        class="ml-1"
        style="display: inline-block"
      ></b-skeleton>
      <b-skeleton
        type="button"
        class="ml-1"
        style="display: inline-block"
      ></b-skeleton>
      <b-skeleton
        type="button"
        class="ml-1"
        style="display: inline-block"
      ></b-skeleton>
      <b-skeleton-table
        v-if="!dataLoaded"
        :rows="10"
        :columns="7"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
    </b-card-body>
    <b-tabs v-if="dataLoaded" v-model="tabIndex" card>
      <b-tab
        v-for="item in gateways"
        v-bind:key="item.id"
        :title="item.website_name"
      >
        <b-row class="mb-3">
          <b-col>
            <b-button variant="success ml-3" @click="exportExcel()"
              >خروجی اکسل</b-button
            >
          </b-col>
          <b-col class="text-right">
            <b style="font-size: 14px; font-weight: 800"
              >مبلغ قابل برداشت:
              {{ Number(item.willpayfuture).toLocaleString() }}</b
            >
            <b-button variant="success ml-3" @click="SetActiveGateway(item)"
              >تسویه</b-button
            >
          </b-col>
        </b-row>
        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="getSettlementList"
        >
          <template v-slot:cell(setteled)="row">
            <span
              :class="
                row.item.setteled == 3
                  ? 'text-success'
                  : row.item.setteled == 2
                  ? 'text-primary'
                  : 'text-warning'
              "
              >{{
                row.item.setteled == 3
                  ? "تسویه شده"
                  : row.item.setteled == 2
                  ? "در حال تسویه"
                  : "تسویه نشده"
              }}</span
            >
          </template>
          <template v-slot:cell(print)="row">
            <b-button
              @click="ShowDetails(row.item.id)"
              class="btn btn-success"
              size="sm"
              style="padding: 3px"
              >جزییات</b-button
            >
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import numberSeprator from "../../components/numberSeprator.vue";
export default {
  name: "settlments",
  components: { numberSeprator },
  data() {
    return {
      dataLoaded: false,
      settlementList: [],
      gateways: [],
      tabIndex: 0,
      activeGateway: null,
      fields: [
        {
          key: "nickname",
          label: "نام دارنده حساب",
        },
        {
          key: "bank_name",
          label: "نام بانک",
        },
        {
          key: "shaba_number",
          label: "شماره شبا",
        },
        {
          key: "datetime_insert",
          label: "تاریخ ثبت",
        },
        {
          key: "tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "amount",
          label: "مبلغ برداشتی",
        },
        {
          key: "topic_id",
          label: "مربوط به درگاه ها",
          formatter(value, key, item) {
            return value == 51 ? "دلار " : "ریال";
          },
        },
        {
          key: "setteled",
          label: "وضعیت",
        },
        {
          key: "print",
          label: "",
        },
      ],
      docDetails: null,
    };
  },
  methods: {
    ShowDetails(id) {
      console.log(id);
      httpHelper.getData("documentDetail?id=" + id).then((res) => {
        this.docDetails = res.result;
        this.$bvModal.show("transactionDetails");
      });
    },
    SetActiveGateway(gateway) {
      this.activeGateway = gateway;
      this.activeGateway.amount = 0;
      this.$bvModal.show("settlment");
    },
    save() {
      httpHelper
        .postData("settlementRequest", this.activeGateway)
        .then((res) => {
          this.$bvModal.hide("settlment");
          this.getdata();
        });
    },
    exportExcel() {
      httpHelper.getData("getSattlments?excel=1").then((res) => {
        if (res.success) {
          const anchor = document.createElement("a");
          const filename = "settlments.xlsx";
          anchor.setAttribute("download", filename);
          anchor.setAttribute("href", res.result);
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        }
      });
    },
  },
  mounted() {
    this.dataLoaded = false;
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تسویه حساب" }]);
    httpHelper.getData("getSattlableGateways").then((res) => {
      this.gateways = res.result;
      httpHelper.getData("getSattlments").then((res) => {
        this.dataLoaded = true;
        this.settlementList = res.result.map((element) => {
          return {
            id: element.id,
            des: element.des,
            datetime_insert: persianDate.getDateByFormat(
              element.datetime_insert
            ),
            amount:
              element.bed > 0
                ? Number(element.bed).toLocaleString()
                : Number(element.bes).toLocaleString(),
            tracking_number: element.tracking_number,
            nickname: element.nickname,
            bank_name: element.bank_name,
            shaba_number: element.shaba_number,
            setteled: element.bed > 0 ? 3 : element.topic_id != 13 ? 2 : 1,
            gateway_id: element.gateway_id,
            topic_id: element.topic_id,
          };
        });
      });
    });
  },
  computed: {
    getSettlementList() {
      if (this.gateways.length == 0) {
        return [];
      }
      var self = this;
      return this.settlementList.filter(function (o) {
        return o.gateway_id == self.gateways[self.tabIndex].id;
      });
    },
  },
};
</script>
